/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { useCourseFrameContext } from '@coursera-web/course-frame';

import { breakpoints } from '@coursera/cds-core';

import ItemFeedback from 'bundles/content-feedback/components/cds/ItemFeedback';
import type { ItemType } from 'bundles/content-feedback/constants/ItemTypes';
import type { Item } from 'bundles/learner-progress/types/Item';

type Props = React.PropsWithChildren<{
  className?: string;
  hideFeedback?: boolean;
  // TODO: Delete the fanout of unused courseId
  courseId?: string;
  computedItem?: Item;
  feedbackType?: ItemType;
}>;

const ItemBox = ({ className, computedItem, feedbackType, hideFeedback, children }: Props) => {
  const itemBoxContentStyle = css`
    max-width: 960px;
    color: var(--cds-color-neutral-primary);
    margin-top: var(--cds-spacing-300);
    ${breakpoints.up('sm')} {
      margin-top: var(--cds-spacing-400);
    }
    ${breakpoints.up('md')} {
      margin-top: var(--cds-spacing-600);
    }
  `;

  const itemFeedbackContainerStyle = css`
    border-top: 1px solid var(--cds-color-grey-25);
    padding: 15px 0;
    display: flex;
  `;

  /* Override the margin-top for the CourseFrame experience in which margin/spacing
  is handled by the CourseFrame Layout component. */
  const courseFrameMarginOverride = css`
    margin-top: 0 !important;
  `;

  const { isCourseFrameEnabled } = useCourseFrameContext();

  return (
    <div className={className} css={[itemBoxContentStyle, isCourseFrameEnabled && courseFrameMarginOverride]}>
      {children}

      {!hideFeedback && computedItem && feedbackType && (
        <div css={itemFeedbackContainerStyle}>
          <ItemFeedback computedItem={computedItem} itemFeedbackType={feedbackType} />
        </div>
      )}
    </div>
  );
};

export default ItemBox;
